import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    bbDoesCustomerHaveAccessToModule, bbFormattedDateString,
    bbGetModulePropertyFromIdOrName,
    BBModuleIcon, bbShortenString, bbSortIpCompare,
    filterObject,
    getFirstCustomerId,
    mapObject
} from "../../../../util/bbHelpers";
import {
    fetchCustomers,
    fetchTargets,
    setCustomerInView,

} from "../../../../actions";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import Tooltip from "@material-ui/core/Tooltip";
import SystemTargetToggleSwitch from "../../controllers/SystemTargetToggleSwitch";
import BBDataTable from "../../tables/BBDataTable";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";
import {Chip} from "@material-ui/core";
import BBIconComputerBugCVE from "../../../../assets/bbCustomIcons/BBIconComputerBugCVE";
import {GpsNotFixedSharp} from "@material-ui/icons";

const TableContainer = (props) => {

    const {customerId} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, customerInView, loadingTargets, loadingTargetsError, metaTargets} = useSelector(({customer}) => customer);
    // const {authUser} = useSelector(({auth}) => auth);

    const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customerId ? customers[customerId] : customerInView ? customers[customerInView] : null : null;
  //from the customer, pull the ACTIVE target data if it exists
  const activeTargets = customer ? customer.targets ? filterObject(customer.targets, (_, target) => target.IsActive !== false) : null : null;
  const totalNumTargets = (metaTargets && metaTargets[customer.CustomerId] && metaTargets[customer.CustomerId].targets) ? metaTargets[customer.CustomerId].targets : null;
  const targetsBatchSize = (metaTargets && metaTargets[customer.CustomerId] && metaTargets[customer.CustomerId].page_size) ? metaTargets[customer.CustomerId].page_size : 10;
  const [localPagewiseLoading, setLocalPagewiseLoading] = useState(false);
    const [pageJustFetched, setPageJustFetched] = useState({});
  const [willBeDoneLocalPagewiseLoadingWhenTargetsIs, setWillBeDoneLocalPagewiseLoadingWhenTargetsIs] = useState(targetsBatchSize);

  useEffect(() => {
    // console.log("Targets Table for customerId: ", customerId, " customer: ", customer, " activeTargets: ", activeTargets)
    // console.log("TargetsTable here is the metaTargets store", metaTargets)
    if (!customers && !loadingCustomers) {
      // console.log("Customers is empty, fetching.")
      dispatch(fetchCustomers());
    } else if (customer && activeTargets === null && !loadingTargets) {
          // console.log("targets is empty, fetching targets for customerId = ", customer.CustomerId);
          dispatch(fetchTargets({
              customerId: customer.CustomerId
          }));
    } else if (customers && customerInView === null) {
        const defaultId = getFirstCustomerId(customers);
        // console.log("setting view to default customer, first in list: ", defaultId);
        dispatch(setCustomerInView(defaultId));
    }
    else if (!loadingTargets && customers && activeTargets && (Object.keys(activeTargets).length < totalNumTargets)) {
        //some of the targets are missing, so preload them for the customer and for the vlun table
        const numTargetsOnHand = Object.keys(activeTargets).length;
        const numMissingTargets = totalNumTargets - numTargetsOnHand;
        // console.log("There are ", numTargetsOnHand, "numTargetsOnHand and ",totalNumTargets, "totalNumTargets.  Fetching more. here are the targets", activeTargets )
        //what is the next page to fetch?
        const pageToFetch = numTargetsOnHand % targetsBatchSize ?  Math.ceil(numTargetsOnHand/targetsBatchSize) : Math.ceil(numTargetsOnHand/targetsBatchSize) + 1;
        setLocalPagewiseLoading(true);
        const numNewTargetsExpected = numMissingTargets < targetsBatchSize ? numTargetsOnHand + numMissingTargets : numTargetsOnHand + targetsBatchSize;
        setWillBeDoneLocalPagewiseLoadingWhenTargetsIs( numNewTargetsExpected);
        if (pageToFetch !== pageJustFetched[customer.CustomerId]) {
            console.log("Fetching page", pageToFetch, "and setting setWillBeDoneLocalPagewiseLoadingWhenTargetsIs to ", numNewTargetsExpected, "and page just fetched:", pageJustFetched);

            setTimeout(() => {
                dispatch(fetchTargets({
                    customerId: customer.CustomerId,
                    pageNumber: pageToFetch,
                    silentLoading: true
                }));
            }, 500)

            setPageJustFetched({...pageJustFetched, [customer.CustomerId]: pageToFetch });
        }
    }

    //check to see if we got a local pagewise load
      if(!loadingTargets && localPagewiseLoading && activeTargets && Object.keys(activeTargets).length >= willBeDoneLocalPagewiseLoadingWhenTargetsIs) {
          //pagewise load should have completed, stop the loading flag
          // console.log("Recieved a pagewise load. activeTargets is", activeTargets );
          setLocalPagewiseLoading(false);
      }
    // console.groupEnd()
  }, [customers, customerId, customerInView, activeTargets, dispatch, loadingCustomers, loadingTargets, customer, localPagewiseLoading,
            pageJustFetched, targetsBatchSize, totalNumTargets, willBeDoneLocalPagewiseLoadingWhenTargetsIs]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={"tourStepAllSystemTargetsTable"}>
        All System Targets <Tooltip title={"System Targets include hosts, routers, servers, etc. They are distinct from Human Targets."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

  const userTableHeadings = [
      // { field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
      // { field: 'id', headerName: 'ID', hide: true, flex : 2, sortable: true, type: 'string', },
      { field: 'scope', headerName: 'Scope',
          renderHeader: (params) => <Tooltip title={"Target Scope"}><span><GpsNotFixedSharp style={{fontSize:"17px"}}/></span></Tooltip>,
          hide: false, sortable: true, type: 'string', width: 68,
          renderCell: (params) => (
              <SystemTargetToggleSwitch
                  customerId={params.row.customerId}
                  targetId={params.row.id}
                  targetProperty={"OutOfScope"}
              />
          ),
      },
      { field: 'diffDays', headerName: 'Duration', hide: false, sortable: true, type: 'string', width : 125,
          renderCell: (params) => {


          return <>

                      <Tooltip
                          title={params.row.isNew
                              ? `This target was recently discovered ${params.value} days ago on ${bbFormattedDateString(params.row.dateAdded, "short")} and was last observed ${bbFormattedDateString(params.row.dateLastObserved, "medium")}.`
                              : `This target has been tracked for ${params.value} days. It was discovered on ${bbFormattedDateString(params.row.dateAdded, "short")} and was last observed ${bbFormattedDateString(params.row.dateLastObserved, "medium")}.`
                          }>
                          <div>
                              <Chip
                                  label={`${params.row.isNew ? 'New: ': ''}${params.value} Days`}
                                  // variant={"outlined"}
                                  // avatar={names.avatar}
                                  size={"small"}
                                  color={params.row.isNew ? "primary" : "default"}
                                  // className={"mr-1"}
                                  // onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}
                              />
                          </div>
                      </Tooltip>

              </>

          }
          ,
      },
      { field: 'ipAddress', headerName: 'IP', hide: false, sortable: true, type: 'string', flex : 1,
          renderCell: (params) => (
              <>
                  {/*{!params.row.isNew &&*/}
                  {/*<Tooltip*/}
                  {/*    title={`This target was recently added on ${bbFormattedDateString(params.row.dateAdded, "short")} and was last observed ${bbFormattedDateString(params.row.dateLastObserved, "medium")}`}>*/}
                  {/*    <div>*/}
                  {/*        <Chip*/}
                  {/*            label={"New"}*/}
                  {/*            // variant={"outlined"}*/}
                  {/*            // avatar={names.avatar}*/}
                  {/*            size={"small"}*/}
                  {/*            color={"primary"}*/}
                  {/*            className={"mr-1"}*/}
                  {/*            // onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}*/}
                  {/*        />*/}
                  {/*    </div>*/}
                  {/*</Tooltip>*/}
                  {/*}*/}

                  <code>{params.value}</code>
              </>

          )
          ,
          sortComparator: (v1, v2, param1, param2) => {
              try{
                  // console.log("IP column sort params", param1, param2);
                  return bbSortIpCompare(param1.value, param2.value);
              } catch(e) {
                  console.warn(e);
                  return false;
              }
          }
      },

      { field: 'domain', headerName: 'Domain', hide: false, sortable: true, type: 'string', flex : 2,renderCell: (params) => {
          if (params.row.domainTooltip) {
              // return <Tooltip title={`Fully Qualified Domain Names: ${params.value}`}>
              //             <code>
              //                 {params.value}
              //             </code>
              // </Tooltip>
              return <small><code>
                      {params.value}
                  </code></small>
          } else {
              return params.value
          }

          }},
      { field: 'os', headerName: 'OS', sortable: true, type: 'string', width: 75, renderCell: (params) => (
              <Tooltip title={`Target Operating System: ${params.value} | ${params.row.osDetailsDescription}`}>
                    <span>
                        {(params.row.osDetails && params.row.osDetailsLogo) && <img style={{height: 18}} src={params.row.osDetailsLogo} alt={`${bbShortenString(params.value, 25, true)}`} />}
                        {(!params.row.osDetails || !params.row.osDetailsLogo) && params.value}
                    </span>
              </Tooltip>
          )},
      { field: 'services', headerName: 'Services', sortable: true, type: 'string', flex : 1.2, renderCell: renderCellExpand},
      { field: 'ports', headerName: 'Ports', sortable: true, type: 'string', flex : 1.1, renderCell: renderCellExpand},
      { field: 'vulnerabilities', headerName: 'CVEs Found', renderHeader: (params) => <Tooltip title={"CVEs Present?"}><span><BBIconComputerBugCVE style={{fontSize: "20px"}}/></span></Tooltip>, hide: true, sortable: true, type: 'string', width : 75, renderCell: renderCellExpand},
      { field: 'lastObserved', headerName: 'Last Observed', sortable: true, type: 'string', flex : 1.2, renderCell: (params) => (
          renderCellExpand(params,
              <>
                  <Tooltip title={`This target was last seen ${bbFormattedDateString(params.row.dateLastObserved, "long")}`}>
                    <span>
                        {bbFormattedDateString(params.row.dateLastObserved, "short")}
                    </span>
                  </Tooltip>
              </>
              ))},
      { field: 'lastObservedUTC', hide: true, headerName: 'Last Observed (UTC)', sortable: true, type: 'string', flex : 1.5, renderCell: (params) => (
              renderCellExpand(params,
                  <>
                      <Tooltip title={`This target was last seen ${bbFormattedDateString(params.row.dateLastObserved, "utc")}`}>
                    <span>
                        {bbFormattedDateString(params.row.dateLastObserved, "utc")}
                    </span>
                      </Tooltip>
                  </>
              ))},

  ];

    //peel the state data into a form the dataTable can read
  const tableData = activeTargets ? mapObject(activeTargets, (key, target) => {
    const calcDiffDays = () => {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

        const firstDate = bbDangerousStringToDate(target["Date First Added"])
        const secondDate = new Date();

        return Math.round(Math.abs((firstDate - secondDate) / oneDay));
    }

      return (
        {
            customerId: customer.CustomerId,
            id: key,
            scope : target.OutOfScope !== "1" ? "In Scope" : "Out of Scope",
            ipAddress: target.IpAddress,
            isNew: target.IsNew,
            dateAdded: target["Date First Added"],
            dateLastObserved: target["Date Last Observed"],
            diffDays: calcDiffDays(),
            domain: target.Fqdn
                ? Array.isArray(target.Fqdn)
                    ? target.Fqdn.length > 0
                        ? target.Fqdn.join(", ")
                        : "None detected"
                    : target.Fqdn
                : "None detected",
            domainTooltip: target.Fqdn
                ? Array.isArray(target.Fqdn)
                    ? target.Fqdn.length > 0
                        ? true
                        : false
                    : true
                : false,
            os: target.OsDetails.Name,
            osDetailsLogo: target.OsDetails.Logo,
            osDetailsDescription: target.OsDetails.Description,
            osDetails: target.OsDetails,
            // // Services: target.Services ? Object.keys(target.Services).length ? Object.keys(target.Services).length : "None detected" : "None detected",
            services: target.Services
                ? Array.isArray(target.Services)
                    ? target.Services.length > 0
                        ? target.Services.join(", ")
                        : "None detected"
                    : target.Services
                : "None detected",
            ports: target.Ports
                ? Array.isArray(target.Ports)
                    ? target.Ports.length > 0
                        ? target.Ports.join(", ")
                        : "None detected"
                    : target.Ports
                : "None detected",
            vulnerabilities: target.Vulnerabilities
                ? Array.isArray(target.Vulnerabilities)
                    ? target.Vulnerabilities.length > 0
                        // ?
                        ? "Yes"
                        : "No"
                    : typeof target.Vulnerabilities === "string"
                        // ? bbStringOfVulnsFromTarget(target)
                        ? "Yes"
                        : "Yes"

                : "No",
        }
    )
  }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }


    return (
        <div >
            {((activeTargets || totalNumTargets === 0) && !loadingTargetsError && !loadingTargets) ?
            <BBDataTable
                columns={userTableHeadings}
                rows={tableDataAsArray()}
                totalRows={totalNumTargets}
                progressValue={activeTargets ? Object.keys(activeTargets).length / totalNumTargets * 100 : 0}
                bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                title={title}
                enableExport
                loading={false}
                requiresModule={"monitor"}
                customer={customer}
                topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                defaultSortModel = {[
                    {
                        field: 'diffDays',
                        sort: 'asc',
                    },
                    {
                        field: 'domain',
                        sort: 'asc',
                    }

                ]}
            />
            :
            <BBDataTable
                columns={userTableHeadings}
                rows={[]}
                title={title}
                loading = {true}
                progressValue={0}
                bufferValue={0}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer